export default __webpack_public_path__ + "static/media/capybara.dfcd0ddc.png";